/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export function MeridianModel(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/models/Beta_Eater.glb')
  const { actions } = useAnimations(animations, group)
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="Base"
          castShadow
          receiveShadow
          geometry={nodes.Base.geometry}
          material={materials.Sat_Mat}
        />
        <group name="Back_CTRL" position={[0, 0.259, -0.32]}>
          <mesh
            name="Back_Plate"
            castShadow
            receiveShadow
            geometry={nodes.Back_Plate.geometry}
            material={materials.Sat_Mat}
            position={[0, -0.259, 0.32]}
          />
          <group name="TP_Deployment_Box" position={[0.008, 0.047, -0.428]} scale={0.232} />
        </group>
        <group name="Right_CTRL" position={[0.34, 0.287, -0.009]}>
          <mesh
            name="Right_Plate"
            castShadow
            receiveShadow
            geometry={nodes.Right_Plate.geometry}
            material={materials.Sat_Mat}
            position={[-0.34, -0.287, 0.009]}
          />
          <group name="TP_Star_Tracker" position={[0.057, -0.31, 0.106]} scale={0.232} />
        </group>
        <group name="Left_CTRL" position={[-0.33, 0.287, -0.009]}>
          <mesh
            name="Left_Plate"
            castShadow
            receiveShadow
            geometry={nodes.Left_Plate.geometry}
            material={materials.Sat_Mat}
            position={[0.33, -0.287, 0.009]}
          />
        </group>

      </group>
    </group>
  )
}

useGLTF.preload('/models/Beta_Eater.glb')
